export default __webpack_public_path__ + "static/media/milestone 7.b2316617.svg";